module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "chap-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('h1', {
    staticClass: "pre_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "bar",
      "src": "images/CH_art.jpg"
    }
  })])]), _c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("WELCOME TO"), _c('br'), _vm._v("ENNEAGRAM DAILY REFLECTIONS")])]), _c('h1', {
    staticClass: "pre_stit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_vm._v("Suzanne Stabile")])]), _c('h1', {
    staticClass: "pre_sstit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "fig-003",
      "src": "images/DINGBAT_art.jpg"
    }
  })])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("T")]), _vm._v("he Enneagram is about nine ways of seeing. The reflections in this series are written from each of those nine ways of seeing. You have a rare opportunity, while reading and thinking about the experiences shared by each author, to expand your understanding of how they see themselves and how they experience others.")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-0010"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/Enneagram.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("I’ve committed to teaching the Enneagram, in part, because I believe every person wants at least these two things: to belong, and to live a life that has meaning. And I’m sure that learning and working with the Enneagram has the potential to help all of us with both.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Belonging is complicated. We all want it, but few of us really understand it. The Enneagram identifies—with more accuracy than any other wisdom tool I know—why we can achieve belonging more easily with some people than with others. And it teaches us to find our place in situations and groups without having to displace someone else. (I’m actually convinced that it’s the answer to world peace, but some have suggested that I could be exaggerating just a bit.)")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("If our lives are to have meaning beyond ourselves, we will have to develop the capacity to understand, value, and respect people who see the world differently than we do. We will have to learn to name our own gifts and identify our weaknesses, and the Enneagram reveals both at the same time.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The idea that we are all pretty much alike is shattered by the end of an introductory Enneagram workshop or after reading the last page of a good primer. But for those who are teachable and open to receiving Enneagram wisdom about each of the nine personality types, the shock is accompanied by a beautiful and unexpected gift: they find that they have more compassion for themselves and more grace for others and it’s a guarantee. ")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("The authors in this series, representing the nine Enneagram types, have used that compassion to move toward a greater understanding of themselves and others whose lives intersect with theirs in big and small ways. They write from experiences that reflect racial and cultural differences, and they have been influenced by different faith beliefs. In working with spiritual directors, therapists, and pastors they identified many of their own habits and fears, behaviors and motivations, gifts and challenges. And they courageously talked with those who are close to them about how they are seen and experienced in relationship. ")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As you begin reading, I think it will be helpful for you to be generous with yourself. Reflect on your own life—where you’ve been and where you’re going. And I hope you will consider the difference between change and transformation. "), _c('i', [_vm._v("Change")]), _vm._v(" is when we take on something new. "), _c('i', [_vm._v("Transformation")]), _vm._v(" occurs when something old falls away, usually beyond our control. When we see a movie, read a book, or perhaps hear a sermon that we believe “changed our lives,” it will seldom, if ever, become transformative. It’s a good thing and we may have learned a valuable life lesson, but that’s not transformation. Transformation occurs when you have an experience that changes the way you understand life and its mysteries.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When my dad died, I immediately looked for the leather journal I had given to him years before with the request that he fill it with stories and things he wanted me to know. He had only written on one page:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_centre last retrait_autre"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_c('i', [_vm._v("Anything I have achieved or accomplished in my life is because of the gift of your mother as my wife. You should get to know her. ")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I thought I knew her, but I followed his advice, and it was one of the most transformative experiences of my life.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("From a place of vulnerability and generosity, each author in this series invites us to walk with them for forty days on their journeys toward transformation. I hope you will not limit your reading to only your number. Read about your spouse or a friend. Consider reading about the type you suspect represents your parents or your siblings. You might even want to read about someone you have little affection for but are willing to try to understand.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("You can never change "), _c('i', [_vm._v("how")]), _vm._v(" you see, but you can change what you "), _c('i', [_vm._v("do")]), _vm._v(" with how you see.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 66
// module chunks = 0